<div class="tabs" id="tabs-1" style="background: white;">
        
 
  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large; text-align: center;">Basic Skills Exam <br>
        (Prueba De Habilidades Básicas)</label>
  
  </div><br><br>
  


     
          <form id="basicexamform"  [formGroup]="regForm"  (ngSubmit)="step12Submitted(regForm)" > 
  
  
          <div class="container-fluid">
  
          <br>
  
          <div class="row">
                  <div class="col-sm-12  col-md-12 col-lg-12 ">
              
  
      <div class="form-group">

      <label style="font-weight: bold;font-size: 20px;">Question 1</label>
      <br>
              <div>
                  <div>
                      How would you feel if you knew someone who was dying and they were angry and depressed because their family was avoiding them?<br />
                      <hr />&#191;C&#0243;mo se sentir&#0237;a si conociera a alguien que est&#0225; muri&#0233;ndose y est&#0225; enojado y
                      deprimido porque su familia lo &#40;a&#41; ha estado eludiendo?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label>
                                

                                <input class="form-check-input" type="radio"   formControlName="Question1" value = "1">That it is his or her problem and you shouldn't get involved.&#47;&#47;&#47;
                                  Ese es problema de esa persona y usted no deber&#0237;a involucrarse.
                    
                              </label>
                          </li>
                          <li>
                              <label>

                                
                                <input class="form-check-input" type="radio"  formControlName="Question1" value = "2">Change the subject and hope he or she will find an answer to this problem on his own.&#47;&#47;&#47;
                                  Cambia de tema y espera que la persona encuentre una respuesta por s&#0237; misma a ese problema.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question1" value = "3">Try and spend sometime with him/her and be a good listener and try to be sympathetic to his needs.&#47;&#47;&#47;
                                  Trata y le dedica alg&#0250;n tiempo a esa persona y la escucha y trata de comprender sus necesidades.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question1" value = "4">Show him that you too are angry with the way his family is acting. It's terrible that they don't visit a dying man.&#47;&#47;&#47;
                                  Le demuestra que a usted tambi&#0233;n le enoja la forma en la cu&#0225;l 

                                  su familia act&#0250;a. Es terrible que no visiten a 
                             
                              </label>                                    
                              un hombre que est&#0225; muriendo.un hombre que est&#0225; muriendo.
                           
                          </li>
                        

                      </ul>
                     
                  </div>
              </div>
     
              <label style="font-weight: bold;font-size: 20px;">Question 2</label>
              <div>
                  <div class="question">
                      Your neighbor fell down a flight of stairs and has injured her hip and can't get up.  She is crying hysterically.  While waiting for the ambulance, you say:<hr />
                      Su vecina se cay&#0243; de unos escalones y se ha lastimado la cadera y no se puede
                      levantar. Ella est&#0225; llorando hist&#0233;ricamente. Mientras espera la ambulancia, usted
                      dice
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question2" value = "1">Stop crying, it shouldn't hurt that much.&#47;&#47;&#47;
                                  Pare de llorar, no deber&#0237;a dolerle tanto.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question2" value = "2">I'll stay with you and hold your hand until the ambulance arrives.&#47;&#47;&#47;
                                  Me quedar&#0233; con usted y le sostendr&#0233; la mano hasta que llegue la ambulancia.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question2" value = "3">Don't worry, it's probably not broken.&#47;&#47;&#47;
                                  Nose preocupe probablemente no est&#0225; rota.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question2" value = "4">What will the other neighbors think when they see you crying? &#47;&#47;&#47;
                                  Qu&#0233; van a pensar los otros vecinos cuando la vean llorar.
                              </label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 3</label>
              <div>
                  <div class="question">
                      If a person drinks 200cc of coffee and 150cc of juice with an English muffin in the morning, 250cc milk with a sandwich at lunch time and 300cc of tea in the evening with dinner, what is the total amount of cc fluid intake taken that day?<hr />
                      Si una persona bebe 200cc de caf&#0233; y 150cc de jugo con un English muffin durante la mafiana, 250cc de leche con un <i>sandwich</i> a la hora del almuerzo y 300cc de t&#0233; en la noche con la cena, &#191;cu&#0225;l es la cantidad total de cc de liquido ingerido ese
                      d&#0237;a?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question3" value = "1">650cc</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question3" value = "2">800cc</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question3" value = "3">900cc</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question3" value = "4">850cc</label>
                          </li>
                      </ul>
                      
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 4</label>
              <div>
                  <div class="question">
                      While caring for a relative in a wheelchair, at their home, you see and smell smoke.  What should you do?<hr />
                      Mientras est&#0225; cuidando a un pariente que est&#0225; en una silla de ruedas, en su casa,usted ve y siente olor a humo. &#191;Qu&#0233; deber&#0237;a hacer usted?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question4" value = "1">Get the relative out of the house and call the fire department from a neighbor's house.&#47;&#47;&#47;
                                  Sacar a su pariente de la casa y Hamar a los bomberos desde un tel&#0233;fono de un vecino.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question4" value = "2">Go find the source of the fire and try to put it out.&#47;&#47;&#47;
                                  Ir a buscar el lugar donde se inici&#0243; el fuego y tratar de apagarlo.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question4" value = "3">Get out of the house quick, call for help, and then return for the relative.&#47;&#47;&#47;
                                  Salir de la casa r&#0225;pidamente, pedir ayuda, y luego volver a buscar a su pariente.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question4" value = "4">Call the fire department from the house and stay inside until they get there.&#47;&#47;&#47;
                                  Llamar a los bomberos desde la casa y quedarse adentro hasta que ellos lleguen.
                              </label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 5</label>
              <div>
                  <div class="question">
                      If the Doctor has prescribed a patient to eat 1400 calories a day and this patient has already eaten the following: <br />
                      Breakfast 300 cal; Lunch 450 cal; Dinner 250 cal; Snack 150 cal.How many more calories must this patient eat to meet the doctor's requirement? <hr />
                      Si el Doctor ha prescrito que un paciente coma 1400 calorias por d&#0237;a y este paciente ya ha comido lo siguiente:
                      Desayuno 300 cal; Almuerzo 450 cal; Cena 250 cal; Refrigerio 150 cal. &#191;Cu&#0225;ntas calor&#0237;as m&#0225;s debe ingerir este paciente para cumplir con lo dispuesto por el m&#0233;dico?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question5" value = "1">500</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question5" value = "2">350</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question5" value = "3">200</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question5" value = "4">250</label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 6</label>
              <div>
                  <div class="question">
                      When you go to work, you need to be clean, dressed neatly, and on time: <hr />
                      Cuando usted va a trabajar, necesita estar limpio&#40;a&#41;, vestir en forma pulcra, y estar puntualmente. (HAGA UN C&#0205;IRCULO)
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question6" value = "1">True &#47;&#47;&#47; Verdadero</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question6" value = "2">False &#47;&#47;&#47; Falso</label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 7</label>
              <div>
                  <div class="question">
                      A person tells you that they are having chest pain and difficulty breathing.  You should: <hr />
                      Una persona le dice que est&#0225; teniendo dolor en el pecho y dificultades para respirar. Usted deber&#0237;a:
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question7" value = "1">Call an ambulance. &#47;&#47;&#47;
                                  Llamar a una ambulancia.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question7" value = "2">Watch to see if this person gets worse. &#47;&#47;&#47;
                                  Observar para ver si esta persona empeora.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question7" value = "3">Tell them it might stop, it's probably gas. &#47;&#47;&#47;
                                  Decide que podr&#0237;a parar, probablemente sean gases.
                              </label>
                          </li>
                          <li>
                              <label>
                                <input class="form-check-input" type="radio"  formControlName="Question7" value = "4">Ignore the complaint. &#47;&#47;&#47;
                                  lgnorar la queja.
                              </label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 8</label>
              <div>
                  <div class="question">
                      You answer the phone while baby-sitting.  The caller asks for Mr. or Mrs. Miller but they are out to dinner and the movies.  The caller asks you to take a message stating
                      &#147; Tell Mrs. Miller that their travel reservations have been confirmed and either she or Mr. Miller can pick up the tickets before Thursday at 5:00pm at the office.
                      Please call before Thursday to let us know if they will need any additional reservations to be made. My phone number is nine-five-six-two-three-eight. My name is Bill.	&#148;
                      How would you record this message? <hr />
                      Usted responde el tel&#0233;fono mientras esta cuidando a un ni&#0241;o. La persona que llama pregunta por el Sr. o la Sra. Miller pero ellos han salido a cenar y al cine.
                      La persona que llama le pide que tome un mensaje diciendo "D&#0237;gale a la Sra. Miller que sus reservas para el viaje han sido confirmadas, y que ella o el Sr.
                      Miller pueden retirar los pasajes en la oficina antes del jueves a las 5:00 PM. Por favor ll&#0255;menos antes del jueves si es que van a necesitar que se haga alguna
                      reservaci&#0243;n adicional. Mi n&#250;mero es nueve-cinco-seis-dos-tres-ocho. Mi nombre es Bill.<br /> &#191;C&#0243;mo registrar&#0237;a usted este mensaje?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question8" value = "1">Caller and Message &#47;&#47;&#47; Llamada y mensaje</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question8" value = "2"> Time and Return Number &#47;&#47;&#47; N&#0250;mero de tiempo y devoluci&#0243;n</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question8" value = "3"> All of the Above &#47;&#47;&#47; Todo lo de arriba</label>
                          </li>

                      </ul>

                    
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 9</label>
              <div>
                  <div class="question">
                      If you become sick and can't work it is not important to let the office know right away. <hr />
                      Si usted se enferma y no puede ir a trabajar no es importante avisar a la oficina en forma inmediata.
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question9" value = "1">True &#47;&#47;&#47; Verdadero</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question9" value = "2">False &#47;&#47;&#47; Falso</label>
                          </li>
                      </ul>
                     
                  </div>
              </div>
              <label style="font-weight: bold;font-size: 20px;">Question 10</label>
              <div>
                  <div class="question">
                      What is the name of our agency and what position are you applying for? <hr />
                      &#191;Cu&#0225;l es el nombre de su agencia y cu&#0225;l es la posici&#0243;n para la cual usted est&#0225; solicitando ingresar?
                  </div>
                  <div class="answers">
                      <ul>
                          <li>
                              <label>Agency:</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question10" value = "1">Premier Home Health Care Services Inc.,</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question10" value = "2">Personal Health Care Services</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question10" value = "3">Home Care Services Inc.</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question10" value = "4">Home Care Interim Health Care</label>
                          </li>
                      </ul>
                     
                      <ul>
                          <li>
                              <label>Position:</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "1">HHA</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "2">CNA</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "3">PCA</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "4">Companion</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "5">RN</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "6">LPN</label>
                          </li>
                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "7">HHA Training</label>
                          </li>

                          <li>
                              <label><input class="form-check-input" type="radio"  formControlName="Question11" value = "8">HCA</label>
                          </li>

                      </ul>
                    
                      <hr />
                  </div>
              </div>
  
      </div>
  
  
  
                  </div>
          </div>
  
        <br/>
  
        </div>


        
    <br/>

    <button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>Prev Page</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >Save and Continue &nbsp;
  <i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   
  

  <div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> Saving Data...</i>
  
          </form>
  
                   
  

</div>
   